
// Import English translations
import enCommon from './en/common.json';
import enNavigation from './en/navigation.json';
import enLayout from './en/layout.json';
import enAuth from './en/auth.json';
import enDashboard from './en/dashboard.json';
import enHooks from './en/hooks.json';
import enProfile from './en/profile.json';
import enPages from './en/pages.json';
import enBrand from './en/brand.json';
import enGamification from './en/gamification.json';
import enSkiner from './en/skiner.json';
import enWallet from './en/wallet.json';
import enComponents from './en/components.json';
import enNotifications from './en/notifications.json';
import enSettings from './en/settings.json';
import enActions from './en/actions.json';
import enNearby from './en/nearby.json';
import enContacts from './en/contacts.json';
import enQr from './en/qr.json';
import enTips from './en/tips.json';
import enForms from './en/forms.json';
import enStates from './en/states.json';
import enTransfer from './en/transfer.json';

// Import Spanish translations
import esCommon from './es/common.json';
import esNavigation from './es/navigation.json';
import esLayout from './es/layout.json';
import esAuth from './es/auth.json';
import esDashboard from './es/dashboard.json';
import esHooks from './es/hooks.json';
import esProfile from './es/profile.json';
import esPages from './es/pages.json';
import esBrand from './es/brand.json';
import esGamification from './es/gamification.json';
import esSkiner from './es/skiner.json';
import esWallet from './es/wallet.json';
import esComponents from './es/components.json';
import esNotifications from './es/notifications.json';
import esSettings from './es/settings.json';
import esActions from './es/actions.json';
import esNearby from './es/nearby.json';
import esContacts from './es/contacts.json';
import esQr from './es/qr.json';
import esTips from './es/tips.json';
import esForms from './es/forms.json';
import esStates from './es/states.json';
import esTransfer from './es/transfer.json';

// Import French translations
import frCommon from './fr/common.json';
import frNavigation from './fr/navigation.json';
import frAuth from './fr/auth.json';
import frWallet from './fr/wallet.json';

// Import Portuguese translations
import ptCommon from './pt/common.json';
import ptNavigation from './pt/navigation.json';

export const resources = {
  en: {
    translation: {
      common: enCommon,
      navigation: enNavigation,
      layout: enLayout,
      auth: enAuth,
      dashboard: enDashboard,
      hooks: enHooks,
      profile: enProfile,
      pages: enPages,
      brand: enBrand,
      gamification: enGamification,
      skiner: enSkiner,
      wallet: enWallet,
      components: enComponents,
      notifications: enNotifications,
      settings: enSettings,
      actions: enActions,
      nearby: enNearby,
      contacts: enContacts,
      qr: enQr,
      tips: enTips,
      forms: enForms,
      states: enStates,
      transfer: enTransfer
    }
  },
  es: {
    translation: {
      common: esCommon,
      navigation: esNavigation,
      layout: esLayout,
      auth: esAuth,
      dashboard: esDashboard,
      hooks: esHooks,
      profile: esProfile,
      pages: esPages,
      brand: esBrand,
      gamification: esGamification,
      skiner: esSkiner,
      wallet: esWallet,
      components: esComponents,
      notifications: esNotifications,
      settings: esSettings,
      actions: esActions,
      nearby: esNearby,
      contacts: esContacts,
      qr: esQr,
      tips: esTips,
      forms: esForms,
      states: esStates,
      transfer: esTransfer
    }
  },
  fr: {
    translation: {
      common: frCommon,
      navigation: frNavigation,
      auth: frAuth,
      wallet: frWallet,
      // Fallback to English for missing translations
      layout: enLayout,
      dashboard: enDashboard,
      hooks: enHooks,
      profile: enProfile,
      pages: enPages,
      brand: enBrand,
      gamification: enGamification,
      skiner: enSkiner,
      components: enComponents,
      notifications: enNotifications,
      settings: enSettings,
      actions: enActions,
      nearby: enNearby,
      contacts: enContacts,
      qr: enQr,
      tips: enTips,
      forms: enForms,
      states: enStates,
      transfer: enTransfer
    }
  },
  pt: {
    translation: {
      common: ptCommon,
      navigation: ptNavigation,
      // Fallback to English for missing translations
      layout: enLayout,
      auth: enAuth,
      dashboard: enDashboard,
      hooks: enHooks,
      profile: enProfile,
      pages: enPages,
      brand: enBrand,
      gamification: enGamification,
      skiner: enSkiner,
      wallet: enWallet,
      components: enComponents,
      notifications: enNotifications,
      settings: enSettings,
      actions: enActions,
      nearby: enNearby,
      contacts: enContacts,
      qr: enQr,
      tips: enTips,
      forms: enForms,
      states: enStates,
      transfer: enTransfer
    }
  }
};
